export const languages = {
  nl: "Nederlands",
};

export const defaultLang = "nl";

export const ui = {
  nl: {
    processor: "verwerkende dienst",
    personaldata: "welke gegevens?",
    grantees: "ontvanger",
    type: "categorie",
    formal_framework: "rechtmatigheid",
    audience: "publiek",
  },
} as const;
